import * as React from "react";

import * as styles from "../footer/footer.module.scss";

import ButtonCv from "../../atoms/link/button-cv";

/**
 * @type {Object} 「UI:Organisms - フッター コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 *
 */

const Footer = () => {
  return (
    <footer className={`${styles.globalfooter}`}>
      <div className={`${styles.footerContainer}`}>
        <div className={`${styles.brandContainer}`}>
          <div className={`${styles.logo}`}>
            <a href="/">
              <img
                src="https://images.ctfassets.net/mc0chld4pn1r/7bPBGwpCTIXNrQEndmCspB/d5f58fe9374a423a4ee03ab9e78c58d9/basixs-logo__1_.svg"
                alt="BAsixs（ベーシックス）"
                width="auto"
                height="76"
              />
            </a>
          </div>
          <div>
            <ButtonCv url="/contact/" label="お問い合わせ" />
          </div>
          <ul className={`${styles.snsList}`}>
            <li key={"sns1"}>
              <a
                href="https://www.facebook.com/basixs.0118"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://images.ctfassets.net/mc0chld4pn1r/4r2x7PLKMGwSy7nhwmLBXz/db2df82d63c245f08d14ed161d68b0aa/sns-share-icon-facebook.svg"
                  alt="BAsixs（ベーシックス） Facebook アカウント"
                  width="32"
                  height="33"
                />
              </a>
            </li>
            <li key={"sns2"}>
              <a
                href="https://twitter.com/BAsixs_"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://images.ctfassets.net/mc0chld4pn1r/2yAo6ZsP84yXr2YuGqvQTX/4b2bcb802fefbc5ca918d827f132b7dc/sns-share-icon-x.svg"
                  alt="BAsixs（ベーシックス） X アカウント"
                  width="32"
                  height="33"
                />
              </a>
            </li>
          </ul>
        </div>
        <div className={`${styles.sitemapContainer}`}>
          <nav>
            <ul className={`${styles.sitemapList}`} aria-label="Site Map">
              <li key={"sitemap1"}>
                <ul>
                  <li key={"sitemap1-1"}>
                    <h2>
                      <a href="/introduction/">BAsixsサイトの紹介</a>
                    </h2>
                  </li>
                  <li key={"sitemap1-2"}>
                    <h2>
                      <a href="/tags/">キーワード一覧</a>
                    </h2>
                  </li>
                  <li key={"sitemap1-3"}>
                    <h2>
                      <a href="/times/columns/">BAsixsコラム</a>
                    </h2>
                  </li>
                  <li key={"sitemap1-4"}>
                    <h2>
                      <a href="/times/stories/">BAsixsストーリーズ</a>
                    </h2>
                  </li>
                </ul>
              </li>
              <li key={"sitemap2"}>
                <ul>
                  <li key={"sitemap2-1"}>
                    <h2>
                      {/* テスト */}
                      <a href="/tools/">お役立ちツール</a>
                    </h2>
                    <ul>
                      <li key={"sitemap2-1-1"}>
                        <a href="/tools/materials/">お役立ち資料</a>
                      </li>
                      <li key={"sitemap2-1-2"}>
                        <a href="/tools/wiki/">用語解説</a>
                      </li>
                    </ul>
                  </li>
                  <li key={"sitemap2-2"}>
                    <h2>
                      <a href="/services/">サービス概要</a>
                    </h2>
                    <ul>
                      <li key={"sitemap2-2-1"}>
                        <a href="/services/offer/">提供サービス</a>
                      </li>
                      <li key={"sitemap2-2-2"}>
                        <a href="/services/works/">事例紹介</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li key={"sitemap3"}>
                <ul>
                  <li key={"sitemap3-1"}>
                    <h2>
                      <a href="/contact/">お問い合わせ</a>
                    </h2>
                  </li>
                  <li key={"sitemap3-2"}>
                    <h2>
                      <a href="/news/">お知らせ</a>
                    </h2>
                  </li>
                </ul>
              </li>
              <li key={"sitemap4"}>
                <ul>
                  <li key={"sitemap4-1"}>
                    <h2>
                      <a class="global-nav-external-link" href="https://www.b-architects.com/" target="_blank" rel="noopener noreferrer">運営会社</a>
                    </h2>
                    <ul>
                      <li key={"sitemap4-1-1"}>
                        <a class="global-nav-external-link" href="https://www.b-architects.com/" target="_blank" rel="noopener noreferrer">ビジネス・アーキテクツ</a>
                      </li>
                    </ul>
                  </li>
                  <li key={"sitemap4-2"}>
                    <h2>
                      <a href="/recruitment/">人材募集</a>
                    </h2>
                    <ul>
                      <li key={"sitemap4-2-1"}>
                        <a href="/recruitment/partner/">
                          ビジネスパートナー募集
                        </a>
                      </li>
                      <li key={"sitemap4-2-2"}>
                        <a href="/recruitment/employee/">正社員募集</a>
                      </li>
                    </ul>
                  </li>
                  <li key={"sitemap4-3"}>
                    <h2>
                      <a href="/site-policy/">サイト利用規約</a>
                    </h2>
                  </li>
                  <li key={"sitemap4-4"}>
                    <h2>
                      <a href="/privacy-policy/">個人情報保護基本方針</a>
                    </h2>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className={`${styles.copyright}`}>
        <p>© Business Architects Inc.</p>
      </div>
    </footer>
  );
};

export default Footer;
